var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "FrontSearcherEmployee"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.SickTest
    }
  }, [_vm._v("Sick Test")]), _vm._v(" "), (_vm.SickTestData) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.SickTestData)
    }
  }) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95e6aca0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/vue/FrontSearcherEmployee.vue
// module id = 199
// module chunks = 0